export * from './delete-bericht.service';
export * from './delete-bericht.service.module';